import { InjectionToken } from '@angular/core';

import { ErrorLogger } from './error-logger.model';

export const ERROR_LOGGERS = new InjectionToken<ErrorLogger[]>('ERROR_LOGGERS');
